import { useCallback, useEffect, useRef } from "react";

import config from "config/appConfig";

import { useNavigate } from "react-router-dom";

import type ApiError from "../core/ApiError";

const { GLOBAL_CONSTANTS, CORE_URLS } = config;

const useUnAuthorizedInterceptor = () => {
	const navigate = useNavigate();

	const navigateRef = useRef(navigate);

	useEffect(() => {
		navigateRef.current = navigate;
	}, [navigate]);

	return useCallback(({ status }: ApiError) => {
		if (status === 401) {
			for (const key in localStorage) {
				if (key.includes(GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX ?? "")) localStorage.removeItem(key);
			}
			const url = `${window.location.pathname}${window.location.search}`;
			navigateRef.current(`${CORE_URLS.LOGIN}?next=${url}`);
		}
	}, []);
};

export default useUnAuthorizedInterceptor;
